export default __webpack_public_path__ + "static/media/white-play-10px.c358a691.svg";